import { makeAuthedRequest } from "utils/makeAuthedRequest";
import { useQuery } from "react-query";
import env from "./environment";

export function useIBOGet() {
  const { data, isLoading, refetch } = useQuery(
    "ibo",
    () =>
      makeAuthedRequest(
        `/ibo`,
        {
          method: "GET",
        },
        env.apiBaseNew
      ).then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error((await res.json()).message);
        }
      }),
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      cacheTime: Infinity,
    }
  );

  return {
    data,
    isLoading,
    refetch,
  };
}
